export const default_language = 'en';

export const default_fonts = [
	'Arial',
	'Times New Roman',
	'Courier New',
	'Georgia',
	'Verdana',
	'Trebuchet MS',
	'Tahoma',
	'Palatino',
	'Comic Sans MS',
	'Impact',
];
